import React from 'react'

export function Team() {
  return (
    <section id="team" className="relative py-24 md:py-32 bg-paper bg-dot-grid">
      <div className="container mx-auto px-4 max-w-3xl text-center">
        <div className="flex items-center justify-center gap-3 mb-5">
          <span className="h-px w-8 bg-ink/15" />
          <span className="eyebrow">§ 02 — Team</span>
          <span className="h-px w-8 bg-ink/15" />
        </div>

        <h2 className="font-display text-4xl md:text-5xl text-ink mb-12 tracking-tightest leading-[1.05]">
          A team that&apos;s lived <span className="italic">the focus problem.</span>
        </h2>

        <p className="font-display text-xl md:text-[1.65rem] text-ink/85 leading-snug">
          NowPilot is built by a small team out of Stanford — engineers
          and researchers who have spent years working on AI systems for
          mental health and well-being. We&apos;ve lived the focus problem
          ourselves, and we&apos;re combining work in human–AI interaction
          with what has actually been shown to help people with ADHD.
        </p>
      </div>
    </section>
  )
}
